import axios from 'axios';
import { MarketId } from 'types/market-id.enum';
import { FishGroupStrain } from 'views/planning-prognosis/features/view-fish-group/types/fish-group-strain.type';

// GET
// /ewosapi/v1/planandprognosis/strains/market/{marketId}
export const getFishGroupStrains = async (marketId: MarketId): Promise<FishGroupStrain[]> => {
  const res = await axios.get<FishGroupStrain[]>(`/ewosapi/v1/planandprognosis/strains/market/${marketId}`);
  return res.data;
};
